<template>
	<div>
		<div class="yznc-header">
			<p class="id-p">
				<input type="number" name=""  @blur="checkUserNum" v-model="uid" value="" placeholder="请输入你的恋爱物语  ID">
				<span class="clearInput" @click="clearInput">×</span>
			</p>
			<p class="yznc-p" v-if="nickname!=''">
				<!--  -->
				<img :src="headImg" alt="">
				<span>{{ nickname }}</span>
				<!-- <span class="yznc-span" @click="checkUserNum">验证昵称</span> -->
			</p>
		</div>

		<div class="package clearfix">
			<p class="package-tit">选择充值套餐（爱豆）</p>
			<!-- <p class="package-item" :class="{hasFree:item.free_amount!=0,on:curIndex==index}"  @click="checkThis(index)" v-for="(item , index) in rangeData">
				<span>{{item.amount}}</span>
				<span v-if="item.free_amount!=0">+{{item.free_amount}}</span>
				<span class="package-item-money">售:{{item.fee}}元</span>
			</p> -->
			<div class="package-item1" :class="{on:curIndex==index}" @click="checkThis(index)" v-for="(item , index) in rangeData">
				<div class="packLeft">
					<div class="packTop">
						<img src="../assets/icon-bean.png"/>
						<span>{{item.amount}}</span>
						<span v-if="item.free_amount!=0">+{{item.free_amount}}</span>
					</div>
					<div v-if="item.prop_list" class="packBottom">
						<div v-for="item1 in item.prop_list">
							<img class="toushiI" :src="item1.img" />
							<span class="toushiT">{{ item1.name }}x{{ item1.validTime }}天</span>
						</div>
					</div>
				</div>
				<div class="packRight">
					<span class="packRightText">售:{{item.fee}}元</span>
				</div>
				
			</div>
		</div>
		<!-- <div class="mb10">
			<p class="package-tit ml4o">选择充值套餐</p>
			<p class="package-acount"><span v-if="curIndex!=-1">{{ rangeData[curIndex].fee }}</span><span v-else>0</span>元</p>
		</div>
		<div class="pay-type">
			<p class="package-tit">支付方式</p>
			<p ><i class="icon-zfb"></i>支付宝<span>></span></p>
			<p><i class="icon-wechat"></i>微信支付<span>></span></p>
		</div>
		-->

		<div class="instructions">
			<p>充值说明</p>
			<p>1、爱豆可以用于恋爱物语语音APP内礼物的购买;</p>
			<p>2、充值订单问题请联系QQ客服：800800664咨询反馈</p>
		</div>
		<div class="payform" v-html='payform'></div>
		<div class="tips" :class="{on:tips!=''}" v-if="tips!=''">
			<p>{{ tips }}</p>
		</div>
		<div class="pop-tips" v-if="isShow" style="display: block;">
			<img :src="imgTip" alt="">
		</div>
	</div>
</template>
<script>
import store from '@/store/store'
import { Params,loading } from '@/util/util.js'
import Qs from 'qs'
	export default {//
		name: 'recharge',
		data (){
			return {
				rangeData:[],
				curIndex:-1,
				isChooseAgreement:false,
				isShowPayBox:false,
				nickname:"",
				headImg:"",
				uid:'',
				tips:'',
				payform:'',
				isShow:false,
				imgTip:require('../assets/pop.png'),
				browser:{
					versions:function(){
							var u = navigator.userAgent, app = navigator.appVersion;
							return {
									trident: u.indexOf('Trident') > -1, //IE内核
									presto: u.indexOf('Presto') > -1, //opera内核
									webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
									gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
									mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
									ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
									android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
									androidChrome:u.match(/Chrome\/([\d.]+)/),// android chrome
									iosChrome: u.match(/CriOS\/([\d.]+)/), // ios chrome
									iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
									iPad: u.indexOf('iPad') > -1, //是否iPad
									safari: u.indexOf('Safari') > -1 && u.indexOf("Chrome") < 1, //是否safari
									weixin: u.indexOf('MicroMessenger') > -1, //是否微信
									qq: u.indexOf('QQ')>-1//是否QQ
							};
					}(),
					language:(navigator.browserLanguage || navigator.language).toLowerCase()
				}
			}
		},
		created(){
			this.$store.commit('inWhichPage',{page:'mobilerecharge'});
		},
		watch:{
			uid (val,oldval) {
				console.log();
				if( this.uid!=oldval && oldval!=""){
					this.nickname = '';
					this.headImg = '';
				}
				if(val.length>8){
					this.uid = val.slice(0,8);
				}
			}
		},
		methods:{
			checkThis(){
				this.curIndex = arguments[0] ;
				this.payCharge();
			},
			toAgreement(){
			},
			clearInput(){
				this.nickname = "" ;
				this.headImg = "" ;
				this.uid = '' ;
			},
			checkUserNum(e){
				const that = this;
				if(that.uid.trim()==""){
					that.showTips("请输入用户账号！！！",that);
				}else{
					var params = new Params(that,{
						uid:that.uid,
						method:'virgift.office.userinfo'
					});
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
	              'Content-Type':'application/x-www-form-urlencoded'
	          }
					}).then(function (res) {
						if (res.data.errCode==0) {
							that.nickname = res.data.data.nickname,
							that.headImg = res.data.data.headImg
						}else{
							that.showTips(res.data.errMsg,that);
							that.uid = '';
							that.nickname = '';
						}
					})
				}
			},
			getBeanList(){
				const that = this;
				loading.show();
				var params = new Params(that,{
					pay_type	:'office_pc',
					method:'virgift.office.bean.shop'
				});
				this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
					headers: {
              'Content-Type':'application/x-www-form-urlencoded'
          }
				}).then(function (res) {
					loading.hide();
					if (res.data.errCode==0) {
						that.rangeData = res.data.data;
						if (that.browser.versions.weixin){
							that.isShow = true;
						}
					}else{
						loading.hide();
						that.showTips(res.data.errMsg,that);
					}
				})
			},
			showTips(tips,that){
				that.tips = tips ;
				setTimeout(()=>{
					that.tips = "" ;
				},3000);
			},
			payCharge(){
				const that = this;
				if(that.nickname.trim()==""){
					that.showTips("请输入用户账号",that);
					return;
				}else if (that.uid.trim()=="") {
					that.showTips("请校验用户账号",that);
					return;
				}else if (that.curIndex==-1) {
					that.showTips("请校验用户账号",that);
					return;
				}else{
					const that = this;

					let pay_type = "" ;

					if (that.browser.versions.mobile) {
						pay_type = "office_mobile";
					}else{
						pay_type = "office_pc";
					}
					var params = new Params(that,{
						pay_type	:pay_type,
						method:'virgift.office.buy.bean',
						bs_id:that.rangeData[that.curIndex].bs_id,
						uid:that.uid
					});
					console.log('params ', params)
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
								'Content-Type':'application/x-www-form-urlencoded'
						}
					}).then(function (res) {
						if (res.data.errCode==0) {
							var str = res.data.data.form;
							that.payform = str;
							that.$nextTick(_=>{ document.forms[0].submit() })
						}else{
							that.showTips(res.data.errMsg,that);
						}
					})
				}
			}
		},
		mounted(){
			this.getBeanList();

		}
	}
</script>
<style scoped>
	.clearInput{
    position: absolute;
    right: 5%;
		color: #999999;
		font-size: 20px;
		padding: 0 15px;
		top: 15px;
	}
	.tips{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		display: none;
		transition: all .5s;
	}
	.tips.on{
		display: block;
	}
	.tips p{
		display: inline-block;
		margin: 60% auto 0;
		color: #ffffff;
		background: rgba(0,0,0,.8);
		border-radius: 5px;
		padding: 15px 20px;
	}
	.id-p{
		height: 34px;
		margin-top: 13px;
	}
	.id-p input{
		font-size: 16px;
		height: 30px;
		width: 92%;
		border: none;
		outline: none;
		line-height: 30px;
	}
	.yznc-p{
		display: inline-block;;
		width: 100%;
		padding: 13px 15px;
		line-height: 32px;
	}

	.yznc-p img{
		height: 32px;
		border-radius: 32px;
		width: 32px;
		display: block;
		float: left;
		margin-right: 5px;
	}

	.yznc-p span{
		font-size: 14px;
		color: #333333;
		float: left;
	}

	.yznc-header{
		border-bottom: 12px solid #D8D8D8;

	}
	.yznc-span{
		ont-size: 16px;
		color: #F54E31;
		margin-right: 4%;
	}
	.package{
		width: 92%;
		margin: 0 auto;
	}
	.package-tit{
		font-size: 14px;
		color: #999999;
		height: 44px;
		line-height: 44px;
		text-align: left;
	}

	.package-item{
		width: 32%;
		float: left;
		height: 84px;
		border: 1px solid #ff8700;
		border-radius: 5px;
		box-sizing: border-box;
		margin-right:2%;
		margin-bottom: 10px;
		background: url("../assets/icon-bean.png") no-repeat 15px 24px;
		background-size: 14px;
		line-height: 66px;
		text-align: left;
		text-indent: 2.3em;
		color: #F44E30;
	}

	.package-item.hasFree,.package-item.on.hasFree{
		line-height: 24px;
		background-position: 15px 16px;
	}


	.package-item span{
		display: block;
		line-height: 20px;
	}

	.package-item span:first-child{
		margin-top: 20px;
	}
	.package-item.hasFree span:first-child{
		margin-top: 13px;
	}
	.package-item.style{
		background: url("../assets/icon-bean.png") no-repeat 15px center;
		background-size: 18px;
	}



	.package-item:nth-child(3n+1){
		margin-right:0;
	}

	.package-item-money{
		font-size: 13px;
		color: rgba(51,51,51,0.8);
	}

	.package-item.on .package-item-money{
		color: #ffffff;
	}

	.package-item.on{
		color: #ffffff;
		background: #ff8700 url("../assets/icon-bean-white.png") no-repeat 20px 22px;
		background-size: 14px;
	}
	.package-item1{
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		border: 1px solid #F4F4F4;
		border-radius: 10px;
		/* height: 62px; */
		padding-top: 15px;
		padding-bottom: 15px;
		margin-top: 10px;
		background-size: 16px;
		text-align: left;
		color: #F34E2F;
	}
	.package-item1.on{
		border: 1.5px solid #FE8601
	}
	.package-item1:first{
		margin-top: 8px;
	}
	.packLeft{
		/* display: flex;
		align-items: center; */
	}
	.packTop img{
		width: 16px;
		height: 13px;
		margin-left: 10px;
		margin-right: 4px;
	}
	.packRight{
		text-align: right;
		margin-left: 5px;
	}
	.packRightText{
		font-size: 14px;
		color: #5C5C5C;
		text-align: right;
		padding-right: 12px;
		width: fit-content;
		white-space: nowrap;
	}
	.packBottom{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.toushiI{
		width: 15px;
		height: 15px;
		margin-left: 10px;
		vertical-align: middle;
	}
	.toushiT{
		font-size: 10px;
		color: #999999;
	}



	.ml4o{
		margin-left: 4%;
	}

	.package-acount{
		width: 92%;
		height: 67px;
		margin: 15px auto;
		background: #F7F7F9;
		border-radius: 4px;
		text-align: left;
		text-indent: 2em;
		line-height: 67px;
		font-size: 20px;
		color: #F54E31;
	}

	.mb10{
		border-bottom: 10px solid #F7F7F9;
	}

	.pay-type{
		width: 92%;
		margin: 0 auto;
		text-align: left;
	}

	.pay-type p:not(:first-of-type){
		font-size: 16px;
		color: #232323;
		height: 48px;
		line-height: 48px;
		border-top: 1px solid #E3E3E3;
	}

	.pay-type p:not(:first-of-type) span{
		font-size: 20px;
		float: right;
		color: #999999;
	}

	.icon-zfb,.icon-wechat{
		width: 24px;
		height: 100%;
		background: url('../assets/icon_recharge_pay_normal.png') no-repeat center;
		background-size: 24px;
		float: left;
		margin-right: 10px;
	}

	.icon-wechat{
		background: url('../assets/icon_recharge_weixin_normal.png') no-repeat center;
		background-size: 24px;
	}
	.instructions{
		padding: 20px 4% 30px;
		background: #F7F7F9;
		margin-top: 30px;
	}
	.instructions p{
		text-align: left;
		font-size: 12px;
		color: #999999;
		line-height: 22px;
	}

	.instructions p:first-child{
		font-size: 14px;
		line-height: 26px;
	}
	.pop-tips {
    display: none;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
		background:rgba(0,0,0,0.8);
}
.pop-tips img{
	width: 18rem;
    position: absolute;
    top: 10px;
    right: 10px;
}

	@media (max-width: 320px){
		.package-item{
			font-size: 14px;
			text-indent: 1.6em;
			background-position: 5px 22px;
		}

		.package-item.on{
			background-position: 5px 22px;
		}

		.package-item.hasFree{
			background-position: 5px 16px;
		}
		.package-item.on.hasFree{
			background-position: 5px 16px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/mobilPage/recharge.vue